/* Blankdays – förslag i varukorgen (fri frakt): + → storleksrad → lägg i varukorgen */
(function () {
  function closeAll(root) {
    root.querySelectorAll('[data-bd-up-panel]').forEach(function (p) { p.hidden = true; });
    root.querySelectorAll('[data-bd-up-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      var item = b.closest('.bd-up__item'); if (item) item.classList.remove('is-active');
    });
  }

  function add(btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(btn.dataset.id), quantity: 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    btn.classList.add('is-loading');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-loading');
      if (res.status) { btn.classList.add('is-error'); setTimeout(function () { btn.classList.remove('is-error'); }, 1500); return; }
      if (drawer && res.sections) {
        res.id = res.items && res.items[0] ? res.items[0].variant_id : undefined;
        drawer.renderContents(res);
      } else {
        window.location.reload();
      }
    }).catch(function () { btn.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-bd-up-toggle]');
    if (toggle) {
      e.preventDefault();
      var root = toggle.closest('.bd-up');
      var panel = root.querySelector('[data-bd-up-panel="' + toggle.dataset.bdUpToggle + '"]');
      var open = panel && panel.hidden;
      closeAll(root);
      if (open) {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        toggle.closest('.bd-up__item').classList.add('is-active');
        var first = panel.querySelector('.bd-up__size:not([disabled])');
        if (first) first.focus({ preventScroll: true });
        panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      return;
    }
    var close = e.target.closest('[data-bd-up-close]');
    if (close) { e.preventDefault(); closeAll(close.closest('.bd-up')); return; }
    var btn = e.target.closest('.bd-up [data-bd-up-add]');
    if (btn) { e.preventDefault(); if (!btn.disabled) add(btn); }
  });
})();
